import API from "./api";

const normalizeInterviewDateForApi = (date) => {
  if (!date) {
    return date;
  }

  if (date instanceof Date && !Number.isNaN(date.getTime())) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const dateValue = String(date).trim();

  const isoDatePattern = /^\d{4}-\d{2}-\d{2}$/;
  const isoDateTimePattern = /^\d{4}-\d{2}-\d{2}T/;
  const ddMmYyyyPattern = /^(\d{2})[/-](\d{2})[/-](\d{4})$/;

  if (isoDatePattern.test(dateValue)) {
    return dateValue;
  }

  if (ddMmYyyyPattern.test(dateValue)) {
    const [, day, month, year] = dateValue.match(ddMmYyyyPattern);
    return `${year}-${month}-${day}`;
  }

  if (
    isoDateTimePattern.test(dateValue) ||
    !Number.isNaN(new Date(dateValue).getTime())
  ) {
    const parsedDate = new Date(dateValue);
    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
    const day = String(parsedDate.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  return dateValue;
};

const groupInterviewsByApplication = (records = []) => {
  const grouped = new Map();

  records.forEach((record) => {
    const applicationId = record.applicationId || record.id;
    if (!applicationId) {
      return;
    }

    const existing = grouped.get(applicationId) || {
      id: applicationId,
      applicationId,
      fullName: record.fullName || "",
      email: record.email || record.candidateEmail || "",
      jobTitle: record.jobTitle || "",
      interviews: [],
    };

    existing.interviews.push(record);
    existing.interviews.sort((left, right) => {
      const leftRank = Number(left.roundNumber || 0);
      const rightRank = Number(right.roundNumber || 0);
      if (leftRank !== rightRank) return leftRank - rightRank;

      const leftDate = new Date(left.date || left.rawDate || 0).getTime();
      const rightDate = new Date(right.date || right.rawDate || 0).getTime();
      return leftDate - rightDate;
    });

    existing.interview =
      existing.interviews[existing.interviews.length - 1] || null;
    grouped.set(applicationId, existing);
  });

  return Array.from(grouped.values());
};

// GET ALL JOBS
export const getJobs = async () => {
  try {
    const response = await API.get("/jobs");
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching jobs:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// GET JOB BY ID  (ADDED TO FIX ERROR)
export const getJobById = async (id) => {
  try {
    const response = await API.get(`/jobs/${id}`);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching job by id:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// CREATE JOB
export const createJob = async (jobData) => {
  try {
    const response = await API.post("/jobs/create", jobData);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching job by id:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// UPDATE JOB
export const updateJob = async (id, jobData) => {
  try {
    const response = await API.put(`/jobs/${id}/update`, jobData);
    return response.data;
  } catch (error) {
    console.error("Error updating job:", error.response?.data || error.message);
    throw error;
  }
};

// DELETE JOB
export const deleteJob = async (id) => {
  try {
    const response = await API.delete(`/jobs/${id}/delete`);
    return response.data;
  } catch (error) {
    console.error("Error deleting job:", error.response?.data || error.message);
    throw error;
  }
};

export const getApplications = async () => {
  try {
    const response = await API.get("/applications/all");
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching applications:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// export const updateApplicationStatus = async (applicationId, status) => {
//   console.log('this is id ',applicationId)
//   try {
//     const response = await API.put(`/applications/${applicationId}/status`, {
//       status,
//     });

//     console.log("Status Updated:", response.data);

//     return response.data;
//   } catch (error) {
//     console.error(
//       "Error updating status:",
//       error.response?.data || error.message
//     );
//     throw error;
//   }
// };

export const updateApplicationStatus = async (applicationId, status) => {
  try {
    const response = await API.put(`/applications/${applicationId}/status`, {
      status,
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error updating status:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const scheduleInterview = async (applicationId, data) => {
  try {
    const payload = {
      ...data,
      date: normalizeInterviewDateForApi(data?.date),
    };

    const response = await API.post(
      `/applications/${applicationId}/schedule-interview`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error scheduling interview:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const scheduleManualInterview = async (data) => {
  try {
    const payload = {
      ...data,
      date: normalizeInterviewDateForApi(data?.date),
    };

    const response = await API.post(
      "/applications/manual-schedule-interview",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error scheduling manual interview:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const getScheduledInterviews = async () => {
  try {
    const response = await API.get("/applications/interviews");

    const records = Array.isArray(response?.data?.data)
      ? response.data.data
      : Array.isArray(response?.data)
        ? response.data
        : [];

    return groupInterviewsByApplication(records);
  } catch (error) {
    console.error(
      "Error fetching interviews:",
      error.response?.data || error.message,
    );

    throw error;
  }
};

export const getInterviewScheduledApplications = async () => {
  try {
    const response = await API.get("/applications/interviews");
    const records = Array.isArray(response?.data?.data)
      ? response.data.data
      : Array.isArray(response?.data)
        ? response.data
        : [];

    return groupInterviewsByApplication(records);
  } catch (error) {
    console.error(
      "Error fetching scheduled interviews:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const getInterviewApplications = async () => {
  try {
    const response = await API.get("/applications/filter");
    return Array.isArray(response?.data?.data) ? response.data.data : [];
  } catch (error) {
    console.error(
      "Error fetching interview applications:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const updateInterview = async (interviewId, data) => {
  try {
    const payload = {
      ...data,
      date: normalizeInterviewDateForApi(data?.date),
    };

    const response = await API.put(
      `/applications/interviews/${interviewId}`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error updating interview:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const updateInterviewResult = async (
  interviewId,
  result,
  remarks = "",
) => {
  try {
    const response = await API.patch(
      `/applications/interviews/${interviewId}/result`,
      { result, remarks },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error updating interview result:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const updateManualInterviewResult = async (data) => {
  try {
    const response = await API.patch(
      "/applications/manual-interview-result",
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error updating manual interview result:",
      error.response?.data || error.message,
    );
    throw error;
  }
};
